import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";
import { eur, fmtDate, fmtDateTime, Loading, StatusBadge } from "@/components/common";
import BackNav from "@/components/BackNav";

export default function InterventoDettaglio() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [zoomPhoto, setZoomPhoto] = useState(false);

  useEffect(() => {
    api.get(`/customer/interventions/${id}`).then((r) => setItem(r.data)).catch(() => {});
  }, [id]);

  if (!item) return <Loading />;

  const rows = [
    ["Servizio", item.service],
    ["Fiori", item.flower_name || "—"],
    ["Pulizia", { inclusa: "Cura ordinaria (inclusa)", nessuna: "Cura ordinaria (inclusa)", ordinaria: "Pulizia ordinaria", approfondita: "Pulizia approfondita", profonda: "Pulizia specialistica", specialistica: "Pulizia specialistica" }[item.cleaning] || "Cura ordinaria (inclusa)"],
    ...(item.extras?.length ? [["Extra", item.extras.map((e) => `${e.name} (${eur(e.price)})`).join(", ")]] : []),
    ...(item.exit_fee > 0 ? [["Uscita aggiuntiva (Extra)", eur(item.exit_fee)]] : []),
    ["Data richiesta", fmtDate(item.created_at)],
    ["Data programmata", item.scheduled_date ? fmtDate(item.scheduled_date) : "Da programmare"],
    ["Intervento effettuato", item.completed_at ? fmtDateTime(item.completed_at) : "—"],
    ...(item.sub_index ? [["Abbonamento", `Uscita ${item.sub_index} di ${item.sub_total}`]] : []),
    ["Luogo", item.grave ? `${item.grave.deceased_name} ${item.grave.deceased_surname}` : "—"],
    ["Cimitero", item.cemetery?.name || "—"],
    ["Professionista", item.professional_name || "In assegnazione"],
  ];
  if (item.price > 0) rows.push(["Importo", eur(item.price)]);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 space-y-8" data-testid="intervention-detail">
      <BackNav />

      <div className="flex items-start justify-between gap-4 flex-wrap">
        <h1 className="font-serif text-4xl text-navy">
          {item.status === "completata" && item.exit_title ? item.exit_title : `Intervento del ${fmtDate(item.completed_at || item.scheduled_date || item.created_at)}`}
        </h1>
        <StatusBadge status={item.status} />
      </div>

      <div className="card-soft p-6">
        <dl className="grid sm:grid-cols-2 gap-x-8 gap-y-4 text-sm">
          {rows.map(([k, v]) => (
            <div key={k}>
              <dt className="label-soft">{k}</dt>
              <dd className="text-navy font-medium">{v}</dd>
            </div>
          ))}
        </dl>
        {item.notes && (
          <div className="mt-4 pt-4 border-t border-[#f1f5f9]">
            <p className="label-soft">Le tue note</p>
            <p className="text-sm text-body">{item.notes}</p>
          </div>
        )}
      </div>

      {item.status === "completata" && item.final_photo ? (
        <div className="card-ivory p-6 space-y-4" data-testid="final-photo-section">
          <p className="font-serif text-2xl text-navy">Siamo stati lì per te.</p>
          <img src={item.final_photo} alt="Fotografia finale dell'intervento" data-testid="final-photo"
            onClick={() => setZoomPhoto(true)} className="w-full rounded-2xl object-cover cursor-zoom-in" />
          {item.completion_notes && <p className="text-sm text-body">Note del professionista: {item.completion_notes}</p>}
        </div>
      ) : (
        <div className="card-ivory p-6 text-sm text-body" data-testid="pending-photo-note">
          Al termine dell'intervento troverai qui la fotografia finale.
        </div>
      )}

      {zoomPhoto && (
        <div className="fixed inset-0 z-[80] bg-[#101c2e]/95 flex items-center justify-center p-4 cursor-zoom-out" onClick={() => setZoomPhoto(false)} data-testid="photo-zoom">
          <img src={item.final_photo} alt="Fotografia finale dell'intervento" className="max-w-full max-h-full object-contain rounded-xl" />
        </div>
      )}
    </div>
  );
}
